import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  //Big heart like

  container: {
    position: "relative",
    display: "inline-block",
  },
  media_img: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  slideWrapper: {
    position: "relative",
  },

  likeOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
  },

  bigHeart: {
    fontSize: 100,
    color: "rgba(255, 0, 0, 0.8)",
    animation: `$pop 0.5s ease-in-out`,
  },

  //Samll heart like
  "@keyframes pop": {
    "0%": { transform: "scale(1)", opacity: 1 },
    "50%": { transform: "scale(1.5)" },
    "100%": { transform: "scale(1)", opacity: 1 },
  },
  favoritePop: {
    animation: `$pop 0.5s ease`,
    transformOrigin: "center center",
    cursor: "pointer",
  },
}));

export default useStyles;
